import { DateTime } from "luxon";

export function formatAmount(number, blur) {

  if(number === "") return "";

  if(number.indexOf(".") >=0){
      
    let numberParts = number.split(".");
    let entero = numberParts[0];
    let decimal = numberParts[1];

    entero = formatNumber(entero);

    if (blur === "blur") {
        decimal += "00";
    }

    decimal = decimal.substring(0, 2);
    number = entero + "." + decimal;
  } else {

      number = formatNumber(number);
      if (blur === "blur") {
          number += ".00";
      }
  }
  return number;
}

export function formatAmount2(number) {

  if(number === "") return "";

  if(number.indexOf(".") >=0){
    let numberParts = number.split(".");
    let entero = numberParts[0];
    let decimal = numberParts[1];
    entero = formatNumber(entero);
    decimal += "00";
    decimal = decimal.substring(0, 2);
    number = entero + "." + decimal;
  }else{
    number = formatNumber(number);
    number += ".00";
  }
  return number;
}

function formatNumber(n) {
  return n.replace(/\D/g, "").replace(/\B(?=(\d{3})+(?!\d))/g, ",")
}

export function validarNumero(texto){
  const re = /^[0-9\b]+$/;
  if (  texto === '' || re.test(texto)) {
    return true;
  } 
  return false;
}

export function ocutarNroCuenta(nroCuenta) {
  return nroCuenta.replace(/\b[\dX][-. \dX]+(\d{4})\b/g, '**** **** **** $1');
}

export function getMsakedEmail(email){
  let skipFirstChars = 1;
  let firstThreeChar = email.slice(0, skipFirstChars);
  let domainIndexStart = email.lastIndexOf("@");
  let domainPlusPreviousChar = email.slice(domainIndexStart-1, email.length);
  return firstThreeChar.concat("*****").concat(domainPlusPreviousChar);
}

export function getMsakedCelphone(nroCuenta) {
  return nroCuenta.replace(/\b[\dX][-. \dX]+(\d{3})\b/g, '******$1');
}

export function paramsUsuario(entries) {
  const result = {}
  for(const [key, value] of entries) {
    if( key === 'nombre' || key === 'apepat' || key === 'apemat'||  key === 'nrodoc'||  key === 'tipodoc'||  key === 'correo'||  key === 'celular'){
      result[key] = value;
    }
  }
  return JSON.stringify(result);
}

export function paramsPoliza(entries) {
  const result = {}
  for(const [key, value] of entries) {
    if( key === 'siscod' || key === 'codprod' || key === 'idpol'||  key === 'numpol' ){
      result[key] = value;
    }
  }
  return JSON.stringify(result);
}

export function validateDateFormat(dateString, format){
  return DateTime.fromISO(dateString.slice(0, 10) + 'T00:00:00.000-05:00' ).toFormat(format);
}

export function showComboValidationCss(cbo, msgValidador){
  
  var styleDropDown = "";
  
  if( !cbo && msgValidador === ''){
      styleDropDown = 'dropdown';
  } else if( !cbo && msgValidador !== ''){
      styleDropDown = 'dropdown dropdown-validador';
  } else if( cbo && msgValidador === ''){
      styleDropDown = 'dropdownListShow';
  } else if( cbo && msgValidador !== ''){
      styleDropDown = 'dropdownListShow dropdownListShow-validador';
  } 
  
  return styleDropDown;

}